import React from 'react';
import { Search } from 'lucide-react';

const StepAdresse = ({ formData, onChange }) => {
  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-orpi-secondary">
        Quelle est votre adresse postale ?
      </h2>

      <p className="text-gray-600 mb-8">
        Indiquez ici votre adresse postale afin de pouvoir recevoir les documents et informations liés à votre demande.
      </p>

      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium mb-1 text-orpi-secondary">
            Adresse
          </label>
          <div className="relative">
            <Search className="absolute left-3 top-3.5 h-5 w-5 text-gray-400" />
            <input
              type="text"
              name="adresse"
              value={formData.adresse}
              onChange={onChange}
              className="w-full pl-10 p-3 border rounded-lg focus:border-orpi-primary focus:ring-orpi-primary"
              placeholder="Sélectionnez une adresse"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1 text-orpi-secondary">
            Complément d'adresse <span className="text-gray-500">(facultatif)</span>
          </label>
          <input
            type="text"
            name="complementAdresse"
            value={formData.complementAdresse}
            onChange={onChange}
            className="w-full p-3 border rounded-lg focus:border-orpi-primary focus:ring-orpi-primary"
            placeholder="Digicode, bâtiment, étage..."
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1 text-orpi-secondary">
            Code Postal
          </label>
          <input
            type="text"
            name="codePostal"
            value={formData.codePostal}
            onChange={onChange}
            className="w-full p-3 border rounded-lg focus:border-orpi-primary focus:ring-orpi-primary"
            placeholder="75001"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1 text-orpi-secondary">
            Ville
          </label>
          <input
            type="text"
            name="ville"
            value={formData.ville}
            onChange={onChange}
            className="w-full p-3 border rounded-lg focus:border-orpi-primary focus:ring-orpi-primary"
            placeholder="Votre ville"
            required
          />
        </div>
      </div>
    </div>
  );
};

export default StepAdresse;